import { render, staticRenderFns } from "./donationAddModal.vue?vue&type=template&id=107ff980&scoped=true&"
import script from "./donationAddModal.vue?vue&type=script&lang=js&"
export * from "./donationAddModal.vue?vue&type=script&lang=js&"
import style0 from "./donationAddModal.vue?vue&type=style&index=0&id=107ff980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ff980",
  null
  
)

export default component.exports